<div class="flex items-center gap-2">
  @if (segments.length) {
    <div [attr.aria-label]="text" class="flex items-start gap-1" role="img">
      @for (available of segments; track $index) {
        <div [class]="available ? 'h-1.5 w-4 rounded bg-green' : 'h-1.5 w-4 rounded bg-gray-200'"></div>
      }
    </div>
  } @else if (limit > 0) {
    <!-- Ab MAX_SEGMENTS ein durchgehender Balken: ein Segment je Lauf sprengte sonst die Zeile. -->
    <div [attr.aria-label]="text" class="h-1.5 w-40 overflow-hidden rounded bg-gray-200" role="img">
      <div [style.width.%]="remainingPercent" class="h-full rounded bg-green"></div>
    </div>
  }
  @if (showText) {
    <p class="text-xs text-gray-500 whitespace-nowrap">{{ text }}</p>
  }
</div>
